export const DESIGN_FAMILIES = [
  ['60_OUT', 'SMO · Smartline outward'], ['60_IN', 'SMI · Smartline inward'],
  ['60_OUT_PLUS', 'SMP · Smartline Plus'], ['COTTAGE', 'Cottage'],
  ['MERANTI', 'Meranti'], ['18_DEG', '18°']
];
export const ALL_DESIGN_FAMILIES = DESIGN_FAMILIES.map(([id]) => id);
export const designSupportsFamily = (row, family) => (row.allowedFamilies ?? ALL_DESIGN_FAMILIES)
  .includes(family === '60_PLUS' ? '60_OUT_PLUS' : family);
